<form [formGroup]="form()" [class.fix]="type() === OrderTimeWindowType.FIX">
  @let controls = form().controls;
  <onyx-form-group class="date" [controls]="controls.date">
    <onyx-datepicker
      [formControl]="controls.date"
      label="labels.day"
      [size]="32"
      [forceError]="isOverlapping()"
      [showErrors]="false"
    ></onyx-datepicker>

    <onyx-suggestions
      [control]="controls.date"
      [suggestions]="DATE_SUGGESTIONS"
    ></onyx-suggestions>
  </onyx-form-group>

  @switch (type()) {
    @case (OrderTimeWindowType.FIX) {
      <onyx-timepicker
        class="fix"
        [formControl]="controls.time"
        [label]="timeWindowTimeLabel()"
        [size]="32"
        [forceError]="isOverlapping()"
      ></onyx-timepicker>
    }
    @default {
      <onyx-form-group class="range" [controls]="controls.timeRange">
        <onyx-timepicker
          [formControl]="controls.timeRange"
          [label]="timeWindowTimeLabel()"
          [size]="32"
          [showTimeRange]="true"
          [forceError]="isOverlapping()"
          [showErrors]="false"
        ></onyx-timepicker>

        <onyx-suggestions
          [control]="controls.timeRange"
          [suggestions]="TIME_RANGE_SUGGESTIONS"
        ></onyx-suggestions>
      </onyx-form-group>
    }
  }

  @let disabled = form().disabled;
  <div class="options">
    @if (!(first() && last())) {
      <onyx-icon-button
        class="remove-button"
        variant="transparent"
        color="gray"
        [size]="32"
        icon="delete-outlined"
        [disabled]="disabled"
        (click)="disabled ? null : remove.emit()"
      ></onyx-icon-button>
    }

    @if (last() && type() !== OrderTimeWindowType.FIX) {
      <div class="separator"></div>

      <onyx-button
        variant="outlined"
        [size]="32"
        leftIcon="add-outlined"
        [disabled]="form().disabled"
        (click)="disabled ? null : add.emit()"
      >
        {{ 'labels.anotherDay' | translate }}
      </onyx-button>
    }
  </div>
</form>

@if (isOverlapping()) {
  <p class="error f-body-xs f-medium">
    {{ `${I18N}.overlapError` | translate }}
  </p>
}
